import Tickets from '../pages/ticket/pages/Tickets'
import CreateTicket from '../pages/ticket/pages/CreateTicket'
import TicketDetails from '../pages/ticket/pages/TicketDetails'
import { USER_ROLES } from '../utils/userRole'

const permissions = [USER_ROLES.ADMIN, USER_ROLES.USER]

const TicketsRoutes = [
  {
    path: '/ticket',
    component: Tickets,
    exact: true,
    permissions,
  },
  {
    path: '/ticket/create',
    component: CreateTicket,
    exact: true,
    permissions: [USER_ROLES.ADMIN],
  },
  {
    path: '/ticket/edit/:id',
    component: CreateTicket,
    exact: true,
    permissions: [USER_ROLES.ADMIN],
  },
  {
    path: '/ticket/details/:id',
    component: TicketDetails,
    exact: true,
    permissions,
  },
]

export default TicketsRoutes
